<template>
  <div>
    <el-page-header
      v-if="author"
      @back="goB"
      title="Back"
      :content="author.name"
    >
    </el-page-header>
    <br />

    <el-row
      class="hidden-md-and-up"
      type="flex"
      justify="space-between"
      align="center"
    >
      <el-col :span="24">
        <el-image
          v-if="author"
          :src="
            author.image_url === null ? '/default-author.png' : author.image_url
          "
          :fit="'cover'"
        ></el-image>
        <el-divider></el-divider>
      </el-col>
    </el-row>

    <el-row :gutter="10" type="flex" justify="space-between" align="center">
      <el-col
        class="hidden-sm-and-down"
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="6"
      >
        <el-image
          id="author_img"
          v-if="author"
          :src="
            author.image_url === null ? '/default-author.png' : author.image_url
          "
          :fit="'cover'"
        ></el-image
      ></el-col>
      <el-col :order="2" :xs="24" :sm="16" :md="24" :lg="24" :xl="24">
        <Quotes v-if="author" :quotes="author.quotes" :author="author"
      /></el-col>
    </el-row>
    <el-backtop target=".el-main"></el-backtop>
  </div>
</template>
<script>
import $HTTP from "../plugins/axios";
import { mapMutations, mapGetters } from "vuex";
import Quotes from "../components/Quotes";
import nav from "../mixins/nav";
export default {
  components: {
    Quotes
  },
  async created() {
    this.getAuthor();
  },
  mixins: [nav],
  computed: {
    authorId() {
      return this.$route.params.id;
    },
    ...mapGetters({
      author: "getAuthor",
      authorQuotes: "getAuthorQuotes"
    })
  },
  data() {
    return {
      localQuotes: [],
      localName: ""
    };
  },
  methods: {
    async getAuthor() {
      const loading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.localQuotes = [];
      const author = (await $HTTP.get(`/author/${this.authorId}/quote`)).data
        .author[0];

      console.log("author", author);
      this.localQuotes = author.quotes;
      this.localName = author.name;
      this.setAuthor(author);
      loading.close();
    },
    goB() {
      this.goBack();
      this.setAuthor(null);
    },
    ...mapMutations(["setAuthor"])
  }
};
</script>
<style scoped>
.rounded-circle {
  border-radius: 50%;
}
.el-image {
  min-height: 250px;
  max-width: 300px;
  width: 42vw;
}
@media only screen and (max-width: 490px) {
  .el-image {
    width: 65vw;
  }
}
</style>
